import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import EditProfile from "@/pages/EditProfile";
import ProfilePage from "@/pages/ProfilePage";
import Opportunities from "@/pages/Opportunities";
import NewOpportunity from "@/pages/NewOpportunity";
import OpportunityDetail from "@/pages/OpportunityDetail";
import Search from "@/pages/Search";
import Admin from "@/pages/Admin";
import Investors from "@/pages/Investors";
import SponsorshipPrograms from "@/pages/SponsorshipPrograms";
import SponsorshipProgramDetail from "@/pages/SponsorshipProgramDetail";
import NewProgram from "@/pages/NewProgram";
import SponsorDashboard from "@/pages/SponsorDashboard";
import Donate from "@/pages/Donate";

function MeRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={`/profile/${user.id}`} replace />;
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/profile/me" element={<MeRedirect />} />
              <Route path="/profile/edit" element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />
              <Route path="/profile/:id" element={<ProfilePage />} />

              <Route path="/opportunities" element={<Opportunities />} />
              <Route path="/opportunities/new" element={<ProtectedRoute roles={["employer", "msme"]}><NewOpportunity /></ProtectedRoute>} />
              <Route path="/opportunities/:id" element={<OpportunityDetail />} />

              <Route path="/search" element={<Search />} />
              <Route path="/investors" element={<Investors />} />
              <Route path="/why" element={<Investors />} />

              <Route path="/sponsorship-programs" element={<SponsorshipPrograms />} />
              <Route path="/sponsorship-programs/new" element={<ProtectedRoute roles={["sponsor", "admin"]}><NewProgram /></ProtectedRoute>} />
              <Route path="/sponsorship-programs/:id" element={<SponsorshipProgramDetail />} />
              <Route path="/sponsor/dashboard" element={<ProtectedRoute roles={["sponsor", "admin"]}><SponsorDashboard /></ProtectedRoute>} />
              <Route path="/donate" element={<Donate />} />

              <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
